
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 15.32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.931 6.117c.386 0 .697.31.697.694v5.394a.697.692 0 11-1.394 0V6.811c0-.384.312-.693.697-.693zm0-2.784c.386 0 .697.31.697.692v.224a.697.692 0 11-1.394 0v-.224c0-.383.312-.692.697-.692z"}}),_c('path',{attrs:{"d":"M6.79 1.204c.983-1.605 3.445-1.605 4.43 0l6.441 10.507c.986 1.609-.245 3.614-2.213 3.614H2.56c-1.967 0-3.198-2.006-2.213-3.613zm3.222.657c-.448-.73-1.567-.73-2.015 0L1.554 12.37c-.446.729.112 1.64 1.007 1.64H15.45c.895 0 1.453-.911 1.007-1.64z"}})])])
          )
        }
      }
    